import OadpCheckboxGroup from './oadp-checkbox-group';
export default OadpCheckboxGroup;
